/* eslint-disable no-unused-vars */
import React from 'react';
import { connect } from 'react-redux';
import { safeAreaInset } from './config';
import { UAParser } from 'utils/index';

const SafeArea = ({
  userAgent = {},
  router = {},
  position = 'top',
  className = ''
}) => {
  const { location = {} } = router;
  const { navigation_bar_hidden } = location.query || {};
  const { iPhoneX, iPhone, pregnancy, CanEatApp } = userAgent;
  if (!iPhone) return null;
  if (position === 'top') {
    if (navigation_bar_hidden && (pregnancy || CanEatApp)) {
      const style = safeAreaInset(
        position,
        iPhone ? (iPhoneX ? 'IPhoneX' : 'IPhone') : 'Default'
      );
      if (!style) return null;
      return (
        <div className={`component-safearea ${className}`} style={style} />
      );
    }
    return null;
  } else {
    const style = safeAreaInset(
      position,
      iPhone ? (iPhoneX ? 'IPhoneX' : 'IPhone') : 'Default'
    );
    return <div className={`component-safearea ${className}`} style={style} />;
  }
};

const mapStateToProps = ({ meta, router }) => ({
  userAgent: meta.userAgent,
  router: router
});

export default connect(mapStateToProps)(SafeArea);

export const getSafeStyle = function (position) {
  const userAgent = UAParser();
  const { iPhoneX, iPhone } = userAgent;
  const style = safeAreaInset(
    position,
    iPhone ? (iPhoneX ? 'IPhoneX' : 'IPhone') : 'Default'
  );
  return style;
};
